import { render, staticRenderFns } from "./StyledHierarchicalMenuList.vue?vue&type=template&id=4896db7e&scoped=true&"
import script from "./StyledHierarchicalMenuList.vue?vue&type=script&lang=js&"
export * from "./StyledHierarchicalMenuList.vue?vue&type=script&lang=js&"
import style0 from "./StyledHierarchicalMenuList.vue?vue&type=style&index=0&id=4896db7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896db7e",
  null
  
)

export default component.exports